import { useGeneratePoleDbXlsx, useRFS } from "@/api/rfs";
import { RequiredAsterisk } from "@/components/form/required-asterisk";
import { Anchor } from "@/components/ui/anchor";
import { DownloadButton } from "@/components/ui/button";
import { P } from "@/components/ui/typography";
import { swalErrorDefault } from "@/utils/lib/swal";
import { ContainerPrimary, ContainerSecondary } from "../ui";

export function PoleDBHandler({
  id,
  hasRequiredAsterisk = false,
}: {
  id: string;
  hasRequiredAsterisk?: boolean;
}) {
  const { data } = useRFS({ id });
  const { mutate: generatePoleDb, isPending: isDownloading } =
    useGeneratePoleDbXlsx();

  function handleDownload() {
    generatePoleDb(
      { id, name: `Asset Pole, Clamp Hook, Qspan-${data?.clusterId}.xlsx` },
      {
        onError: () => {
          swalErrorDefault.fire();
        },
      },
    );
  }

  return (
    <ContainerPrimary>
      <span className="flex-grow whitespace-nowrap">
        Pole DB, Clamp Hook, Qspan{hasRequiredAsterisk && <RequiredAsterisk />}
      </span>
      <ContainerSecondary>
        <P className="invisible flex-grow text-axiata-blue dark:text-neutral-300"></P>
        <DownloadButton onClick={handleDownload} loading={isDownloading} />
        <div className="invisible">
          <Anchor mood="axiata-blue-outline" href="#">
            <p>Detail</p>
          </Anchor>
        </div>
      </ContainerSecondary>
    </ContainerPrimary>
  );
}
